import Utils from '../util/Utils.jsx';
import { updateOfflineDatasetNote, updateOfflineChangeNote } from './db.js';
import { activitySetNote } from '../context/activity.js';

export const setNote = (dispatch, datasetId, allowOffline, noteData) => {
	if (Utils.isOnline()) {
		const postData = Object.assign({ dataset: datasetId }, noteData);
		Utils.ajax('setNote', postData, dispatch, result => {
			if (!noteData.noteId) {
				noteData.noteId = result.noteId;
			}
			dispatch(activitySetNote(noteData));

			if (allowOffline) {
				updateOfflineDatasetNote(datasetId, noteData);
			}
		});
	} else if (allowOffline) {
		updateOfflineDatasetNote(datasetId, noteData, noteData => {
			dispatch(activitySetNote(noteData));
			updateOfflineChangeNote(datasetId, noteData);
		});
	}
};
